module.exports = "/virtual-football/img/video/clubs/italy/lazio.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/clubs/italy/lazio.png
// module id = 301
// module chunks = 6